import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import * as DisabledReasons from 'automation-ui-permissions/feature-permissions/constants/DisabledReasons';
import { useGetFeaturePermission } from 'automation-ui-permissions/feature-permissions/hooks/featurePermissionHooks';
import ReadOnlySourceAppBanner from 'automation-ui-canvas/components/common/ReadOnlySourceAppBanner';
import { combineFeaturePermissions } from 'automation-ui-canvas/utils/featurePermissions';
import { jsx as _jsx } from "react/jsx-runtime";
function FeaturesReadOnlyBanner({
  sourceApp,
  editFeatures,
  flow
}) {
  const getFeaturePermission = useGetFeaturePermission();
  const featurePermissions = editFeatures.map(editFeature => getFeaturePermission({
    sourceApp,
    feature: editFeature
  }));
  const featurePermission = combineFeaturePermissions(featurePermissions);
  const {
    disabledReasons,
    hasQueryError,
    hasFeatureAccess
  } = featurePermission;
  if (hasQueryError) {
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'automation.common.accessErrorBanner.title'
      }),
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'automation.common.accessErrorBanner.content'
      })
    });
  }
  if (!hasFeatureAccess && disabledReasons.includes(DisabledReasons.RESTRICTED_BY_SOURCE_APP)) {
    return /*#__PURE__*/_jsx(ReadOnlySourceAppBanner, {
      flow: flow,
      sourceApp: sourceApp
    });
  }
  if (!hasFeatureAccess) {
    return /*#__PURE__*/_jsx(UIAlert, {
      "data-test-id": "alert-read-only-banner",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.readOnlyBanner.default.title"
      }),
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.readOnlyBanner.default.content"
      })
    });
  }
  return null;
}
export default FeaturesReadOnlyBanner;